import dayjs from 'dayjs'

import { defaultViewDateFormat } from 'shared/constants'
import { IBonusHistoryItemDTO, IConvertedBonusHistory } from 'shared/models/BonusSystem'

import { IDefaultDataResponse } from '../PaymentApi/types/types'

export class BonusSystemConverter {
  convertBonusHistory = (data: IDefaultDataResponse<IBonusHistoryItemDTO>): IConvertedBonusHistory => {
    const bonusHistory =
      data?.results?.map(item => ({
        id: item.id,
        amount: +(+item.amount).toFixed(2),
        amountCurrency: item.amount_currency,
        date: dayjs(item.date).format(defaultViewDateFormat),
        type: item.type,
        bonusBalanceBeforeCurrency: item.bonus_balance_before_currency,
        bonusBalanceBefore: +(+item.bonus_balance_before).toFixed(2),
        bonusBalanceAfterCurrency: item.bonus_balance_after_currency,
        bonusBalanceAfter: +(+item.bonus_balance_after).toFixed(2),
      })) || []

    return {
      page: data.page,
      count: data.count,
      history: bonusHistory,
    }
  }
}
